import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { result } from 'lodash';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-appointmentlist',
  templateUrl: './appointmentlist.component.html',
  styleUrls: ['./appointmentlist.component.css']
})
export class AppointmentlistComponent implements OnInit{
  selectedStatus: any = ''
  memberData: any = [];
  appointmentId: any;
  filteredmemberList:any;
  totalPages = 0;
  totalResults = 0;
  currentPage:number = 1
  numberOfRecords = NUMBER_OF_RECORDS;
  search:any
  status = true
  userPermission=UserPermission
  appointmentTypeModalObj:any;

  constructor(private appointmentTypeService: AppointmentTypeService,public permissionService: PermissionService){

  }

  ngOnInit(){
    this.getAllAppointment(this.currentPage);
  }

  getAllAppointment(page:number){
    const queryparams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.appointmentTypeService.getAppointment(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) =>{
      if(data.results ){
        this.memberData = data.results;
        this.memberData = data.results.sort((a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
      }
    })
  }
  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllAppointment(page);
  }

  onSelectStatus(event: any): void {
   this.status = event.target.value === 'true';
    this.getAllAppointment(this.currentPage = 1);
  }


  openAppointmentTypeModal(appointmentType: any) {
    this.appointmentTypeModalObj = appointmentType;
  }

  onSaveAppointmentType(evt: any) {
    if (evt) {
      const idx = this.memberData.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.memberData[idx] = evt;
      } else {
        this.memberData.splice(idx, 1);
      }
    }
    this.appointmentTypeModalObj = null;
  }

  onCloseAppointmentTypeModal() {
    this.appointmentTypeModalObj = null;
  }

}
